import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { Alert } from '../models/alert.model';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AlertService {
  private headers = new HttpHeaders({ 'ngrok-skip-browser-warning': '1' });

  constructor(private http: HttpClient) { }

  // 🔁 Charger les alertes
  getAlerts(wallet: string): Observable<Alert[]> {
    return this.http.get<{ success: boolean; alerts: Alert[] }>(
      `${environment.backendUrl}/alerts?wallet=${wallet}`,
      { headers: this.headers }
    ).pipe(map(res => res.alerts));
  }

  // ✅ Créer une alerte
  createAlert(alert: Partial<Alert>): Observable<string> {
    return this.http.post<{ success: boolean; alertId: string }>(
      `${environment.backendUrl}/alerts`, // ✅ Corrigé ici
      alert,
      { headers: this.headers }
    ).pipe(map(res => res.alertId));
  }

  deleteAlert(alertId: string): Observable<boolean> {
    return this.http.delete<{ success: boolean }>(
      `${environment.backendUrl}/alerts/${alertId}`,
      { headers: this.headers }
    ).pipe(map(res => res.success));
  }

  // ♻️ Réactiver une alerte déclenchée
  reactivateAlert(alertId: string): Observable<boolean> {
    return this.http.put<{ success: boolean }>(
      `${environment.backendUrl}/alerts/${alertId}/reactivate`,
      {},
      { headers: this.headers }
    ).pipe(map(res => res.success));
  }
}
